import React from "react";
import "../styles/Lacetegindesti.css";

const Lacetegindesti = () => {
  return (
    <section className=" gind-section">
      <div className="grid-cont">
        <div className="grid-it  grid-it-1">
          <div className="text-over">
            <h1 className="heading-secondary">
              Transformă un gând frumos într-un buchet perfect.
            </h1>
            <p className="text-over-text">
              Lasă-ne să creăm o surpriză unică pentru tine sau pentru cei
              dragi. Alege din colecția noastră de flori naturale și bucură-te
              de livrare rapidă.
            </p>
            <a href="#cele-mai-vindute" className="btn buyNow">
              Comanda acum
            </a>
          </div>
          {/* <div style={{ backgroundImage: `url(${backgroundImg})`, backgroundSize: 'cover', height: '100vh' > */}
        </div>
        <div className="grid-it grid-it-2">
          {/* <img src="" alt="Second column image" /> */}
        </div>
      </div>
    </section>
  );
};

export default Lacetegindesti;
